<template>
    <div>
      <div class="ibox float-e-margins">
        <toplist-header></toplist-header>
        <toplist-content></toplist-content>
      </div>
    </div>
  </template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { TOPLIST_SET } from '../../../store/mutation-types'

import Header from './Toplist/Header'
import Content from './Toplist/Content'

export default {
  components: {
    toplistHeader: Header,
    toplistContent: Content
  },
  mounted () {
    this.loadToplist()
  },
  methods: {
    async loadToplist () {
      try {
        let resp = await axios.get(`/advertisers/toplists/${this.$route.params.id}`)
        this.$store.commit(TOPLIST_SET, resp.data)
      } catch (error) {
        this.$toastr.error('Failed loading lists', error)
      }
    }
  },
  computed: {
    ...mapGetters({
      toplist: 'getToplist'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Toplist.vue